import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";

class UserProfilePanel extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            profiles:[],
            search:'',
            page: 1,
            total: 0,
            maxRecords: props.top,
        };
        this.handleChange = this.handleChange.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
    }

    componentDidMount() {
        this.getProfiles()
    }

    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getProfiles()
        });
    }

    handleChange(e){
        this.setState({profiles: [], search: e.target.value, page: 1}, function () {
            this.getProfiles();
        });
    }

    async delete(profile) {
        swal.fire({
            text: "¿Estás seguro que deseas eliminar este perfil?",
            showCancelButton: true,
            icon: "question",
            buttonsStyling: false,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            customClass: {
                confirmButton: "btn font-weight-bold btn-danger",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.deleteProfile(profile.id);
            }
        });
    }

    deleteProfile = (id) => {
        window.blockUI();
        axios.delete(
            'api/profiles/' + id,
            {},
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            this.getProfiles();
            swal.fire({
                text: getSuccessMessage(response),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            });
        })
        .catch((error) => {
            window.unblockUI();
            swal.fire({
                text: 'Algo salió mal, intenta de nuevo',
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        });
    }

    async getProfiles(){
        var url = '/api/profiles';
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('maxRecords', this.state.maxRecords)
        if(this.state.search!=''){
            query.append('search', this.state.search)
        }
        const qs = query.toString();
        const res = await axios.get(url+`?${qs}`);
        const data = res.data.data;
        this.setState({profiles: data, total: res.data.total});
    }

    render() {
        const { lang } = this.context; 
        return (
        <>
            <div className="d-flex flex-column-fluid">
                <div className="container">

        <div className="card card-custom my-5">
            <div className="card-header border-0 pt-6">
                <h3 className="card-title align-items-start flex-column">
                    <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.perfiles')}</span>
                    <span className="text-muted mt-3 font-weight-bold font-size-lg">{this.state.total} {lang.get('messages.perfiles_encontrados')}</span>
                </h3>
                <div className="card-toolbar">
                    <div>
                        <div className="input-icon">
                            <input
                                style={{width: '400px'}}
                                onChange={this.handleChange}
                                name="search"
                                type="text"
                                className="form-control"
                                placeholder={lang.get('messages.buscar_perfiles')} />
                            <span>
                                <i className="flaticon2-search-1 text-primary icon-md"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body">
                <table className="table m-0 table-valign">
                    <thead>
                        <tr>
                            <th>{lang.get('messages.nombre_del_perfil')}</th>
                            <th>No. {lang.get('messages.de_usuarios')}</th>
                            <th>{lang.get('messages.fecha_de_creacion')}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.profiles.map((p, i) => {
                        return <tr key={i}>
                            <td className="p-5">
                                <i className="flaticon2-protected text-primary mr-1"></i>
                                <strong className="ml-2">
                                <a class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg" href={"/profiles/" + p.id + "/edit"}>
                                    {p.name}
                                </a>
                                </strong>
                            </td>
                            <td className="text-muted">{p.users.length}</td>
                            <td className="text-muted">{moment(p.created_at).format('YYYY-MM-DD')  }</td>
                            <td className="text-right">
                                { ( this.props.permissions.profiles.includes('all') || this.props.permissions.profiles.includes('delete') ) &&
                                    <a onClick={()=>{ this.delete(p) }} className="btn btn-xs btn-icon btn-light-secondary mr-4">
                                        <i className="flaticon-delete fw-normal text-primary"></i>
                                    </a>
                                }
                                { ( this.props.permissions.profiles.includes('all') || this.props.permissions.profiles.includes('edit') ) &&
                                <a  href={"/profiles/" + p.id + "/edit"} className="btn btn-xs btn-icon btn-light-secondary mr-4">
                                    <i className="flaticon2-edit text-primary"></i>
                                </a>
                                }
                                { ( this.props.permissions.profiles.includes('all') || this.props.permissions.profiles.includes('list') ) &&
                                <a href={"/profiles/" + p.id } className="btn btn-xs btn-icon btn-light-secondary mr-4">
                                    <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                </a>
                                }
                            </td>
                        </tr>
                        })}
                    </tbody>
                </table>
            </div>
        </div>

        <div className="d-flex justify-content-center align-items-center flex-wrap">
            <div className="d-flex flex-wrap py-2 mr-3">
            {this.state.total > this.state.maxRecords   &&
                <SimplePagination
                    updateCurrentPage={this.updateCurrentPage}
                    currentPage={this.state.page}
                    totalFiles={this.state.total}
                    split={this.state.maxRecords} />
                }
            </div>
        </div>
    </div>
</div>
        </>
        );
    }
}

export default UserProfilePanel;

if (document.getElementById('UserProfilePanel')) {
    ReactDOM.render(<UserProfilePanel />, document.getElementById('UserProfilePanel'));
}
